import { useState, type FormEvent, type ReactNode } from "react";
import { useAuth } from "../auth/AuthProvider.js";
import { Button, Card, Field, FormError } from "../components/index.js";
import { BrandLogo } from "../shell/BrandLogo.js";

export function LoginPage(): ReactNode {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [erro, setErro] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);

  async function handleSubmit(event: FormEvent<HTMLFormElement>): Promise<void> {
    event.preventDefault();
    setErro(null);
    setEnviando(true);
    try {
      await login(email.trim(), senha);
      // O onAuthStateChanged do AuthProvider assume daqui (redireciona).
    } catch (error: unknown) {
      setErro(mensagemErroLogin(error));
    } finally {
      setEnviando(false);
    }
  }

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "var(--bg)",
        padding: "1.5rem"
      }}
    >
      <Card style={{ width: 340 }}>
        <form
          onSubmit={handleSubmit}
          style={{ display: "flex", flexDirection: "column", gap: "0.9rem" }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "0.7rem" }}>
            <BrandLogo size={46} />
            <div style={{ lineHeight: 1.2 }}>
              <div style={{ fontSize: 22, fontWeight: 800, letterSpacing: "0.04em" }}>
                FICC
              </div>
              <p style={{ margin: 0, fontSize: 12.5, color: "var(--text-muted)" }}>
                FBA Inbound Command Center
              </p>
            </div>
          </div>

          <Field label="E-mail" htmlFor="email" required>
            <input
              id="email"
              type="email"
              autoComplete="username"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </Field>

          <Field label="Senha" htmlFor="senha" required>
            <input
              id="senha"
              type="password"
              autoComplete="current-password"
              value={senha}
              onChange={(e) => setSenha(e.target.value)}
              required
            />
          </Field>

          {erro !== null ? <FormError>{erro}</FormError> : null}

          <Button type="submit" fullWidth disabled={enviando}>
            {enviando ? "Entrando…" : "Entrar"}
          </Button>
        </form>
      </Card>
    </div>
  );
}

function mensagemErroLogin(error: unknown): string {
  const code =
    typeof error === "object" &&
    error !== null &&
    "code" in error &&
    typeof (error as { code: unknown }).code === "string"
      ? (error as { code: string }).code
      : "";

  switch (code) {
    case "auth/invalid-email":
      return "E-mail inválido.";
    case "auth/missing-password":
      return "Informe a senha.";
    case "auth/invalid-credential":
    case "auth/wrong-password":
    case "auth/user-not-found":
      return "E-mail ou senha incorretos.";
    case "auth/user-disabled":
      return "Usuário desativado.";
    case "auth/too-many-requests":
      return "Muitas tentativas. Tente novamente em instantes.";
    case "auth/network-request-failed":
      return "Falha de rede. Verifique sua conexão.";
    default:
      return "Não foi possível entrar. Tente novamente.";
  }
}
